var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"avatar avatar-xxl",on:{"click":function($event){return _vm.uploadAvatar($event)}}},[_c('img',{staticClass:"avatar-img rounded-circle",attrs:{"src":"https://via.placeholder.com/350x150","alt":"..."}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0da152","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/backend/profile/Avatar.vue
// module id = null
// module chunks = 